/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import RecordRTC from "recordrtc";
import MuiAlert from "@mui/lab/Alert";
import {
  Paper,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  AppBar,
  Toolbar,
  FormControl,
  InputLabel,
  MenuItem,
  Popover,
} from "@mui/material";
import * as emoji from "node-emoji";
import axios from "../../../utils/axiosConfig";
import { WEB_URL } from "../../../utils/constants";
import { adminBackendURL } from "../../../utils/constants";
import onWindowReload from "../../../utils/reloadFunction";
import { v1_question_images_link } from "./v1-links";
import { useSelector } from "react-redux";
import { getOrgId } from "../../../reducer/dashboardSlice";
import { serverConfig } from "../../../utils/serverConstants";
import { checkAudioQuality } from "./helpers";
import { AudioUploadingModal, WarningModal } from "../../VideoTest/WarningModal";
// import { translationMissingMessage } from "./translationConstants";
import standardAxios from "axios";

// Define styles using Material-UI's makeStyles
const useStyles = makeStyles((_theme) => ({
  root: {
    display: "flex",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: "0px 5px",
  },
  countdownSnackbar: {
    backgroundColor: "#6f2981",
    color: "#ffffff",
    fontWeight: "bold",
    textAlign: "center",
    borderRadius: "4px",
  },
}));

// eslint-disable-next-line unused-imports/no-unused-vars
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// Export a React functional component
export default (props) => {
  const classes = useStyles();
  const {
    testData,
    questionNo,
    setClearFlag,
    clearFlag,
    examId,
    setCheckFlag,
    examDetail,
    _answerStatus,
    setAnswerStatus,
    _marksScored,
    _setMarksScored,
    _totalMarks,
    _setTotalMarks,
    _wrongAnswerCount,
    _setWrongAnswerCount,
    _disable,
    setDisable,
    setTestData,
    windowSwitchCount,
    setWindowSwitch,
    isRecording,
    setIsRecording,
    setIsVideoUploading,
    _isVideoSent,
    setIsVideoSent,
  } = props;

  // Initialize component state
  const [answer, setAnswer] = React.useState(testData[questionNo - 1].descriptiveText);
  const [_error, setError] = React.useState(false);
  const [recordVideo, setRecordVideo] = React.useState(null);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_adminToken, setAdminToken] = React.useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [interimText, setInterimText] = React.useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [finalisedText, setFinalisedText] = React.useState([]);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [listening, setListening] = React.useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_language, setLanguage] = React.useState(examDetail[0].speechlang + "-IN");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [emojiValue, setEmojiValue] = React.useState(0);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_listener, setListener] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [filename, setFilename] = React.useState("");
  const [blobUrl, setBlobUrl] = React.useState(`${WEB_URL}ah-resources/user-files/autoSpeech/` + filename);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [_countdown, setCountdown] = React.useState(3);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_disabled, setDisabled] = React.useState(testData[questionNo - 1].descriptiveText !== null);
  const [startButtonDisabled, setStartButtonDisabled] = React.useState(false);
  const [isRecordingByQuestion, setIsRecordingByQuestion] = React.useState({});
  const [_uploadingStatus, setUploadingStatus] = React.useState({});
  const [_audioUploaded, setAudioUploaded] = React.useState(false);
  let [audioButtonCount, setAudioButtonCount] = React.useState(0);
  const [retryClicked, setRetryClicked] = React.useState(false);
  const [audioPlaying, setAudioPlaying] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [modalType, setModalType] = React.useState("");
  const [showUploadModal, setShowUploadModal] = React.useState(false);
  const [deviceType, setDeviceType] = React.useState("");
  const [isRefreshingAudioUrl, setIsRefreshingAudioUrl] = useState(false);
  const [mediaStream, setMediaStream] = React.useState(null);

  // Handle mouse hover for question number popover
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
    setShowUploadModal(false);
    setStartButtonDisabled(false);
  };

  const handleRetryRecording = () => {
    setShowModal(false);
    setModalType("");
    setShowUploadModal(false);
    setStartButtonDisabled(false);
    setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));
    setIsVideoSent(false);
    setUploadingStatus((prev) => ({
      ...prev,
      [questionNo]: { uploading: false, success: false },
    }));
    setRetryClicked(true);
  };

  // Function to get platform information
  const getPlatformInfo = async () => {
    if (navigator.userAgentData) {
      const uaData = await navigator.userAgentData.getHighEntropyValues(["platform", "platformVersion"]);
      return uaData.platform || "Unknown";
    }
    const ua = navigator.userAgent;
    if (/Windows/i.test(ua)) return "Windows";
    if (/Mac OS X/i.test(ua)) return "macOS";
    if (/Android/i.test(ua)) return "Android";
    if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
    if (/Linux/i.test(ua)) return "Linux";
    return "Unknown";
  };

  // Function to detect device type and browser
  const detectDeviceType = async () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const ua = navigator.userAgent;
    const browser = getBrowserName(ua);
    const platform = await getPlatformInfo();

    if (isMobile) {
      setDeviceType("mobile");
      if (/iPhone|iPad|iPod/i.test(ua) && browser === "Safari") {
        setShowModal(true);
        setModalType("safariWarning");
      }
    } else {
      setDeviceType("desktop");
    }
    console.log("Device Type:", deviceType, "Browser:", browser, "Platform:", platform);
  };

  React.useEffect(() => {
    // Version identifier for production verification
    console.log("🎙️ AutoSpeech Component Loaded - Version: MediaRecorder-iOS-Fix v2.0 (2026-01-27)");
    detectDeviceType();
  }, []);

  // Function to parse browser name from userAgent
  const getBrowserName = (userAgent) => {
    if (/Chrome/i.test(userAgent) && !/CriOS/i.test(userAgent)) return "Chrome";
    if (/CriOS/i.test(userAgent)) return "Chrome";
    if (/Firefox/i.test(userAgent) || /FxiOS/i.test(userAgent)) return "Firefox";
    if (/Edg/i.test(userAgent) || /EdgiOS/i.test(userAgent)) return "Edge";
    if (/Safari/i.test(userAgent) && !/Chrome|CriOS|Edg|EdgiOS|FxiOS|Firefox/i.test(userAgent)) return "Safari";
    return "Unknown";
  };

  // Function to log audio events
  const logAudioEvent = async (status, error = null, additionalLogs = {}) => {
    try {
      const platform = await getPlatformInfo();
      const userAgent = navigator.userAgent;
      const browser = getBrowserName(userAgent);
      const logData = {
        examId: props.examId,
        questionNo: questionNo,
        userId: examDetail[0].userid,
        status,
        errorName: error ? error.name : null,
        errorMessage: error ? error.message : null,
        errorStack: error ? error.stack : null,
        userAgent,
        platform,
        deviceType,
        browser,
        additionalLogs,
      };

      // TODO: Use global admin token from cookies/storage
      standardAxios
        .post(`${adminBackendURL}/api/mobile-testing/audioLogs`, logData)
        .then((res) => console.log("Audio log sent:", res.data))
        .catch((err) => console.error("Error sending audio log:", err));
    } catch (logError) {
      console.error("Error preparing audio log:", logError);
    }
  };

  const checkMicrophonePermission = async () => {
    console.log("Checking microphone permission...");
    try {
      const permissionStatus = await navigator.permissions.query({ name: "microphone" });
      console.log("Microphone permission status:", permissionStatus.state);
      if (permissionStatus.state === "denied") {
        setShowModal(true);
        setModalType(deviceType === "mobile" && /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "permissionDeniediOS" : "permissionDenied");
        await logAudioEvent("failure", null, { action: "checkMicrophonePermission", message: `Microphone permission ${permissionStatus.state}` });
        return false;
      }
      return permissionStatus.state === "granted" || permissionStatus.state === "prompt";
    } catch (error) {
      console.error("Error checking microphone permission:", error);
      setShowModal(true);
      setModalType(deviceType === "mobile" && /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "permissionDeniediOS" : "permissionDenied");
      await logAudioEvent("failure", error, { action: "checkMicrophonePermission" });
      return false;
    }
  };

  onWindowReload(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, testData);

  const open = Boolean(anchorEl);

  const onAnswerText = (text) => {
    setClearFlag(false);
    setCheckFlag(true);

    let temp = answer;

    setTestData((prevTestData) => {
      const updatedTestData = [...prevTestData];
      const currentQuestion = updatedTestData[questionNo - 1];

      currentQuestion.answerStatus = text === currentQuestion.choicetext;

      if (text !== "") {
        currentQuestion.buttonStyle = "Answered";
        currentQuestion.descriptiveText = text;
        setError(false);
      } else {
        currentQuestion.buttonStyle = "Not Answered";
        if (!examDetail[0].answermandatoryflag) {
          setError(true);
        }
      }

      return updatedTestData;
    });

    setAnswerStatus(temp);
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_snackbarOpen, setSnackbarOpen] = React.useState(false);

  // Function to start recording audio
  const startRecord = async () => {
    if (testData[questionNo - 1].descriptiveText !== null) {
      setStartButtonDisabled(true);
      return;
    }
    if (retryClicked) {
      setStartButtonDisabled(false);
      setRetryClicked(false);
      return;
    }

    if (!(await checkMicrophonePermission())) {
      setStartButtonDisabled(false);
      return;
    }

    const questionAudio = document.querySelector("audio");
    if (questionAudio) {
      questionAudio.pause();
      setAudioPlaying(false);
    }

    setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: true }));

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } });

      // Detect iOS devices
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isIOS) {
        // iOS-specific: Use native MediaRecorder API (no Web Workers)
        // MediaRecorder is supported on iOS 14+ and avoids Worker SecurityError
        console.log("✅ iOS DETECTED: Using native MediaRecorder API (NO Web Workers) - v2.0");
        console.log("📱 Device:", navigator.userAgent);

        // Create a wrapper object that mimics RecordRTC interface
        const audioChunks = [];
        const mediaRecorder = new MediaRecorder(stream, {
          mimeType: 'audio/webm;codecs=opus', // iOS Chrome supports webm
        });

        mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            audioChunks.push(event.data);
          }
        };

        // Create RecordRTC-like interface wrapper
        const recordVideoWrapper = {
          startRecording: () => {
            audioChunks.length = 0; // Clear previous chunks
            mediaRecorder.start();
            return Promise.resolve();
          },
          stopRecording: (callback) => {
            mediaRecorder.onstop = () => {
              callback();
            };
            mediaRecorder.stop();
          },
          getBlob: () => {
            return new Blob(audioChunks, { type: 'audio/webm;codecs=opus' });
          },
          stream: stream,
          _isNativeMediaRecorder: true, // Flag to identify this wrapper
        };

        setRecordVideo(recordVideoWrapper);
        setMediaStream(stream);
        await recordVideoWrapper.startRecording();
      } else {
        // Android/Desktop: Use original RecordRTC configuration
        console.log("🖥️ Android/Desktop: Using RecordRTC (original configuration)");
        let recordOptions = {
          type: "audio",
          mimeType: "audio/wav",
        };

        let recordVideo = RecordRTC(stream, recordOptions);
        setRecordVideo(recordVideo);
        setMediaStream(stream);
        await recordVideo.startRecording();
      }

      setIsRecording(true);
      setIsVideoSent(true);
      setUploadingStatus((prev) => ({
        ...prev,
        [questionNo]: { uploading: false, success: false },
      }));
      await logAudioEvent("success", null, { action: "startRecord" });
    } catch (error) {
      console.error("Error accessing microphone:", error);
      setShowModal(true);
      setModalType(deviceType === "mobile" && /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "permissionDeniediOS" : "permissionDenied");
      await logAudioEvent("failure", error, { action: "startRecord" });
      setStartButtonDisabled(false);
    }
  };

  const stopRecord = async () => {
    if (recordVideo) {
      setUploadingStatus((prev) => ({
        ...prev,
        [questionNo]: { uploading: true, success: false },
      }));
      setShowUploadModal(true);
      setIsVideoUploading(true);

      // Note: For iOS MediaRecorder, we do NOT stop tracks before stopRecording
      // MediaRecorder needs the stream active until recording is complete
      // Tracks will be stopped after we get the blob

      try {
        await new Promise((resolve, _reject) => {
          recordVideo.stopRecording(async () => {
            setIsRecording(false);
            setCountdown(3);
            setStartButtonDisabled(true);

            const blob = recordVideo.getBlob();
            const blobSize = blob ? blob.size : 0;
            const blobType = blob ? blob.type : "none";
            console.log("Blob details:", { size: blobSize, type: blobType });

            // Determine file extension and MIME type based on recorder type
            const isIOSMediaRecorder = recordVideo._isNativeMediaRecorder;
            const fileExtension = isIOSMediaRecorder ? "webm" : "wav";
            const audioMimeType = isIOSMediaRecorder ? "audio/webm;codecs=opus" : "audio/wav";

            const filename = `${firstName}_${lastName}_${props.examId}_${testData[questionNo - 1].qid}.${fileExtension}`;
            const audioData = new Blob([blob], { type: audioMimeType });

            // iOS MediaRecorder: Stop stream tracks after getting blob
            if (isIOSMediaRecorder && mediaStream) {
              console.log("iOS MediaRecorder: Stopping stream tracks after blob retrieval");
              mediaStream.getTracks().forEach(track => track.stop());
            }

            if (audioData.size === 0) {
              setShowUploadModal(false);
              setIsVideoUploading(false);
              setShowModal(true);
              setModalType("corruptAudio");
              setStartButtonDisabled(false);
              setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));
              setIsVideoSent(false);
              setUploadingStatus((prev) => ({
                ...prev,
                [questionNo]: { uploading: false, success: false },
              }));
              await logAudioEvent("failure", null, {
                action: "stopRecord",
                message: "Empty audio blob",
                blobDetails: { size: blobSize, type: blobType },
              });
              resolve();
              return;
            }

            try {
              const audioQuality = await checkAudioQuality(audioData, () => {
                console.log("No audio detected in recording");
              });

              if (audioQuality === "no_audio") {
                setShowUploadModal(false);
                setIsVideoUploading(false);
                setShowModal(true);
                setModalType("noAudio");
                setStartButtonDisabled(false);
                setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));
                setIsVideoSent(false);
                setUploadingStatus((prev) => ({
                  ...prev,
                  [questionNo]: { uploading: false, success: false },
                }));
                await logAudioEvent("failure", null, { action: "stopRecord", message: "No audio detected" });
                resolve();
                return;
              }
            } catch (error) {
              console.error("Error checking audio quality:", error);
              setShowUploadModal(false);
              setIsVideoUploading(false);
              setShowModal(true);
              setModalType(error.name === "EncodingError" ? "encodingError" : "corruptAudio");
              setStartButtonDisabled(false);
              setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));
              setIsVideoSent(false);
              setUploadingStatus((prev) => ({
                ...prev,
                [questionNo]: { uploading: false, success: false },
              }));
              await logAudioEvent("failure", error, { action: "checkAudioQuality" });
              resolve();
              return;
            }

            const stringifyExamDetail = JSON.stringify(examDetail);
            const encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)));
            const stringifyTestData = JSON.stringify(testData);
            const encodedTestData = encodeURIComponent(btoa(encodeURIComponent(stringifyTestData)));

            const formData = new FormData();
            formData.append("file", audioData, filename);
            formData.append("examId", examId);
            formData.append("questionNo", questionNo.toString());
            formData.append("examDetail", encodedExamDetail);
            formData.append("testData", encodedTestData);
            formData.append("windowSwitchCount", windowSwitchCount.toString());
            formData.append("remainingTime", window.localStorage.getItem("remainingTime") || "0");

            try {
              const response = await axios.post("/test/uploadaudio", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              });

              if (response.data && response.data.mongoSaved) {
                const { file_url, file_name, file_size, updatedTestData, examDetail: updatedExamDetail } = response.data;

                let decodedUpdatedTestData, decodedUpdatedExamDetail;
                try {
                  const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(updatedTestData)));
                  decodedUpdatedTestData = JSON.parse(decodedTestDataString);

                  const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(updatedExamDetail)));
                  decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);
                } catch (decodeError) {
                  console.error("Error decoding response data:", decodeError);
                  setShowUploadModal(false);
                  setIsVideoUploading(false);
                  setShowModal(true);
                  setModalType("corruptAudio");
                  setStartButtonDisabled(false);
                  setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));
                  setIsVideoSent(false);
                  setUploadingStatus((prev) => ({
                    ...prev,
                    [questionNo]: { uploading: false, success: false },
                  }));
                  await logAudioEvent("failure", decodeError, { action: "decodeResponse" });
                  resolve();
                  return;
                }

                const localUpdatedTestData = [...testData];
                localUpdatedTestData[questionNo - 1] = {
                  ...localUpdatedTestData[questionNo - 1],
                  answerResourcePath: file_url,
                  answerResourceName: file_name,
                  descriptiveText: "Not Required",
                  buttonStyle: "Answered",
                  mongoSaved: true,
                };

                setTestData({
                  ...testData,
                  quesData: decodedUpdatedTestData,
                  examDetail: decodedUpdatedExamDetail || examDetail,
                });

                const collectData = {
                  quesData: decodedUpdatedTestData,
                  examDetail: decodedUpdatedExamDetail || examDetail,
                };
                window.localStorage.setItem(examId, JSON.stringify(collectData));

                setAudioUploaded(true);
                setIsVideoSent(false);
                setCheckFlag(true);
                setUploadingStatus((prev) => ({
                  ...prev,
                  [questionNo]: { uploading: false, success: true },
                }));

                console.log("Audio uploaded and data saved successfully to MongoDB");
                setShowUploadModal(false);
                setIsVideoUploading(false);
                await logAudioEvent("success", null, { action: "uploadSuccess", fileName: file_name, fileSize: file_size });

                resolve();
              } else {
                throw new Error("MongoDB save failed");
              }
            } catch (error) {
              console.error("Error uploading audio file:", error);
              setShowUploadModal(false);
              setIsVideoUploading(false);
              setUploadingStatus((prev) => ({
                ...prev,
                [questionNo]: { uploading: false, success: false },
              }));
              setIsVideoSent(false);
              setStartButtonDisabled(false);
              setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));

              setModalType(
                error && error.response && error.response.data && error.response.data.error === "Uploaded audio file is empty"
                  ? "noAudio"
                  : "corruptAudio"
              );
              await logAudioEvent("failure", error, { action: "upload" });
              resolve();
            }
          });
        });
      } catch (error) {
        console.error("Error stopping recording:", error);
        setShowUploadModal(false);
        setIsVideoUploading(false);
        setUploadingStatus((prev) => ({
          ...prev,
          [questionNo]: { uploading: false, success: false },
        }));
        setIsVideoSent(false);
        setStartButtonDisabled(false);
        setIsRecordingByQuestion((prev) => ({ ...prev, [questionNo]: false }));
        setShowModal(true);
        setModalType(error.name === "EncodingError" ? "encodingError" : "corruptAudio");
        await logAudioEvent("failure", error, { action: "stopRecord" });
      }
    } else {
      setIsVideoSent(false);
      setShowUploadModal(false);
      setIsVideoUploading(false);
    }
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  function getUserMedia(callback) {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(callback)
      .catch((error) => {
        setShowModal(true);
        setModalType(deviceType === "mobile" && /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "permissionDeniediOS" : "permissionDenied");
        logAudioEvent("failure", error, { action: "getUserMedia" });
        setStartButtonDisabled(false);
      });
  }

  const handleAudioClick = async () => {
    handleAudioPlay();
    if (audioButtonCount < 4) {
      setAudioButtonCount(audioButtonCount + 1);
      testData[questionNo - 1].audioButtonCount = audioButtonCount + 1;
    }

    if (audioButtonCount === 4) {
      console.log("chances exhausted");
    }
  };

  const handleAudioPlay = () => {
    if (audioButtonCount < 3) {
      setAudioPlaying(true);
    } else {
      setAudioPlaying(false);
    }
  };

  const handleAudioPause = () => {
    setAudioPlaying(false);
  };

  const handleAudioEnd = () => {
    setAudioPlaying(false);
  };

  React.useEffect(() => {
    setAudioButtonCount(testData[questionNo - 1].audioButtonCount || 0);
    setAudioPlaying(false);
  }, [questionNo - 1]);

  React.useEffect(() => {
    if (!isRecording) {
      setStartButtonDisabled(false);
    }
  }, [isRecording]);

  const orgId = useSelector(getOrgId);

  React.useEffect(() => {
    if (questionNo === testData.length) {
      setDisable(true);
    }
    if (orgId !== undefined && orgId !== "") {
      try {
        axios
          .get("/dashboard/getProfile", {
            headers: {
              "Access-Control-Allow-Origin": "*",
              orgId: orgId,
            },
          })
          .then((profData) => {
            let userData = profData.data.profileData;
            setFirstName(userData.firstname);
            setLastName(userData.lastname);
            setFilename(`${firstName}_${lastName}_${props.examId}_${testData[questionNo - 1].qid}.wav`);
          })
          .catch((_error) => { });
      } catch (error) { }
    }
    setAnswer(testData[questionNo - 1].descriptiveText);
    setBlobUrl(`${WEB_URL}ah-resources/user-files/autoSpeech/` + filename);

    if (clearFlag) {
      testData[questionNo - 1].descriptiveText = "Answered";
      let temp = answer;
      setAnswerStatus(temp);
      setAnswer("");
      testData[questionNo - 1].buttonStyle = "Answered";
      setClearFlag(false);
    }
  }, [clearFlag, answer, blobUrl, finalisedText, filename, questionNo]);

  // useEffect to validate test data when reaching the last question
  React.useEffect(() => {
    if (questionNo === testData.length && firstName && lastName) {
      const validateAudioTestData = async () => {
        try {
          const response = await axios.post("/test/validateAudioTestData", {
            userId: examDetail[0].userid,
            userExamId: examId,
            curQues: questionNo,
            firstname: firstName,
            lastname: lastName,
          });

          const { updatedTestData, examDetail: updatedExamDetail, updatedQuestions, totalQuestions } = response.data;

          if (!updatedTestData || !updatedExamDetail) {
            console.error("Invalid API response:", response.data);
            return;
          }

          try {
            const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(updatedTestData)));
            const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

            const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(updatedExamDetail)));
            const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

            setTestData({
              ...testData,
              quesData: decodedUpdatedTestData,
              examDetail: decodedUpdatedExamDetail,
            });

            const collectData = {
              quesData: decodedUpdatedTestData,
              examDetail: decodedUpdatedExamDetail,
            };
            window.localStorage.setItem(examId, JSON.stringify(collectData));

            console.log(`Validated test data: ${updatedQuestions} questions updated out of ${totalQuestions}`);
          } catch (decodeError) {
            console.error("Error decoding API response:", decodeError);
          }
        } catch (error) {
          console.error("Error validating test data:", error);
        }
      };

      validateAudioTestData();
    }
  }, [questionNo, testData.length, examId, examDetail, testData, setTestData, firstName, lastName]);

  React.useEffect(() => {
    const checkAndRefreshAudioUrl = async () => {
      if (!isRecording && testData[questionNo - 1].answerResourcePath && !isRefreshingAudioUrl && testData[questionNo - 1].qtypeid === "28") {
        const audioUrl = testData[questionNo - 1].answerResourcePath;

        if (audioUrl.includes("?") && audioUrl.includes("se=")) {
          try {
            const url = new URL(audioUrl);
            const expiryParam = url.searchParams.get("se");

            if (expiryParam) {
              const expiryDate = new Date(expiryParam);
              const now = new Date();
              const hoursUntilExpiry = (expiryDate - now) / (1000 * 60 * 60);

              if (hoursUntilExpiry <= 24) {
                console.log(`Audio URL expiring soon (${hoursUntilExpiry.toFixed(2)} hours left), refreshing...`);
                setIsRefreshingAudioUrl(true);

                const response = await axios.post("/test/validateAndRefreshAudioSASUrls", {
                  userExamId: examId,
                });

                if (response.data.urlsRefreshed) {
                  const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(response.data.updatedTestData)));
                  const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

                  const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(response.data.examDetail)));
                  const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

                  setTestData({
                    ...testData,
                    quesData: decodedUpdatedTestData,
                    examDetail: decodedUpdatedExamDetail,
                  });

                  const collectData = {
                    quesData: decodedUpdatedTestData,
                    examDetail: decodedUpdatedExamDetail,
                  };
                  window.localStorage.setItem(examId, JSON.stringify(collectData));

                  console.log("Audio URL refreshed successfully");
                } else {
                  console.log("Audio URL still valid, no refresh needed");
                }

                setIsRefreshingAudioUrl(false);
              }
            }
          } catch (error) {
            console.error("Error checking/refreshing audio URL:", error);
            await logAudioEvent("failure", error, { action: "refreshAudioURL" });
            setIsRefreshingAudioUrl(false);
          }
        } else if (!audioUrl.includes("?")) {
          console.log("Old public URL detected, converting to SAS URL...");
          setIsRefreshingAudioUrl(true);

          try {
            const response = await axios.post("/test/validateAndRefreshAudioSASUrls", {
              userExamId: examId,
            });

            const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(response.data.updatedTestData)));
            const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

            const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(response.data.examDetail)));
            const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

            setTestData({
              ...testData,
              quesData: decodedUpdatedTestData,
              examDetail: decodedUpdatedExamDetail,
            });

            const collectData = {
              quesData: decodedUpdatedTestData,
              examDetail: decodedUpdatedExamDetail,
            };
            window.localStorage.setItem(examId, JSON.stringify(collectData));

            console.log("Converted public URL to SAS URL successfully");
          } catch (error) {
            console.error("Error converting to SAS URL:", error);
            await logAudioEvent("failure", error, { action: "convertToSASURL" });
          }

          setIsRefreshingAudioUrl(false);
        }
      }
    };

    checkAndRefreshAudioUrl();
  }, [questionNo, isRecording, testData, examId, isRefreshingAudioUrl]);

  const getAudioSrc = () => {
    if (isRefreshingAudioUrl) {
      return "";
    }

    if (testData[questionNo - 1].answerResourcePath) {
      return testData[questionNo - 1].answerResourcePath;
    }

    return `${serverConfig.azureSpeechStorageURL}${testData[questionNo - 1].answerResourceName}`;
  };

  return (
    <div>
      <WarningModal open={showModal} onClose={handleCloseModal} modalType={modalType} onRetry={handleRetryRecording} />
      <AudioUploadingModal open={showUploadModal} />
      <Typography
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <span className="question-num">
          Q.{questionNo} of {testData.length}
        </span>
      </Typography>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <h5>{testData[questionNo - 1].qid}</h5>
      </Popover>
      {examDetail[0].selectedLanguage === null ||
        examDetail[0].selectedLanguage === "en-IN" ||
        examDetail[0].include_english === true ||
        (examDetail[0].selectedLanguage !== null && examDetail[0].selectedLanguage !== "en-IN" && testData[questionNo - 1].translated_qtext === null) ? (
        <span style={{ marginBottom: "10px" }} dangerouslySetInnerHTML={{ __html: testData[questionNo - 1].qtext }} />
      ) : null}
      {examDetail[0].selectedLanguage !== null &&
        examDetail[0].selectedLanguage !== "en-IN" &&
        (examDetail[0].include_english === true || testData[questionNo - 1].translated_qtext === null) ? (
        <>
          <br />
          <br />
        </>
      ) : null}
      {examDetail[0].selectedLanguage !== null && examDetail[0].selectedLanguage !== "en-IN" ? (
        <span
          dangerouslySetInnerHTML={{ __html: testData[questionNo - 1].translated_qtext || "" }}
          style={{ marginBottom: "10px" }}
        />
      ) : null}
      <br />
      {testData[questionNo - 1].qresourcepath !== "" && testData[questionNo - 1].audioButtonCount !== 4 ? (
        <>
          <audio
            style={{ marginTop: "10px" }}
            src={
              testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== undefined &&
                testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== null &&
                testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== ""
                ? testData[questionNo - 1].question_resource_url.split("|^^|")[0]
                : v1_question_images_link + testData[questionNo - 1].qresourcepath.split("|^^|")[0]
            }
            controls={!isRecording}
            onPlay={handleAudioClick}
            onPause={handleAudioPause}
            onEnded={handleAudioEnd}
          />
        </>
      ) : (
        <>
          {testData[questionNo - 1].audioButtonCount === 4 && (
            <>
              <br />
              <br />
              <span style={{ color: "red", fontSize: "14px", fontWeight: "bold", padding: "8px", borderRadius: "5px" }}>
                Limit reached: Play audio up to 3 times only.
              </span>
            </>
          )}
        </>
      )}

      {testData[questionNo - 1].answerResourcePath && testData[questionNo - 1].answerResourcePath !== "" ? (
        <>
          <br />
          <br />
          <p style={{ marginBottom: "4px" }}>
            {testData[questionNo - 1].answerResourceName !== null ? <b>Recorded Audio</b> : "Please record the audio"}
          </p>
          {isRefreshingAudioUrl ? (
            <div style={{ padding: "10px", color: "#666", fontSize: "14px" }}>Refreshing audio link...</div>
          ) : (
            <audio
              style={{ marginBottom: "10px" }}
              src={getAudioSrc()}
              controls="controls"
              onError={async (e) => {
                console.error("Audio playback error:", e);
                if (!isRefreshingAudioUrl && testData[questionNo - 1].answerResourcePath) {
                  console.log("Audio load failed, attempting to refresh URL...");
                  setIsRefreshingAudioUrl(true);

                  try {
                    const response = await axios.post("/test/validateAndRefreshAudioSASUrls", {
                      userExamId: examId,
                    });

                    const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(response.data.updatedTestData)));
                    const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

                    const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(response.data.examDetail)));
                    const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

                    setTestData({
                      ...testData,
                      quesData: decodedUpdatedTestData,
                      examDetail: decodedUpdatedExamDetail,
                    });

                    const collectData = {
                      quesData: decodedUpdatedTestData,
                      examDetail: decodedUpdatedExamDetail,
                    };
                    window.localStorage.setItem(examId, JSON.stringify(collectData));

                    console.log("Audio URL refreshed after error");
                  } catch (err) {
                    console.error("Failed to refresh audio URL:", err);
                    await logAudioEvent("failure", err, { action: "audioErrorRefresh" });
                  } finally {
                    setIsRefreshingAudioUrl(false);
                  }
                }
              }}
            />
          )}
        </>
      ) : (
        <></>
      )}

      <br />
      {!isRecording && !testData[questionNo - 1].answerResourcePath && !testData[questionNo - 1].disabled && (
        <>
          <p style={{ marginTop: "10px", marginBottom: "10px" }}>Click below button to start recording</p>
          <Button
            variant="outlined"
            onClick={startRecord}
            disabled={
              isRecordingByQuestion[questionNo] ||
              testData[questionNo - 1].answerResourcePath ||
              testData[questionNo - 1].disabled ||
              audioPlaying ||
              startButtonDisabled
            }
            style={{
              marginBottom: "10px",
              color: "white",
              borderColor:
                isRecordingByQuestion[questionNo] ||
                  testData[questionNo - 1].answerResourcePath ||
                  testData[questionNo - 1].disabled ||
                  audioPlaying ||
                  startButtonDisabled
                  ? "#CCCCCC"
                  : "#4CAF50",
              backgroundColor:
                isRecordingByQuestion[questionNo] ||
                  testData[questionNo - 1].answerResourcePath ||
                  testData[questionNo - 1].disabled ||
                  audioPlaying ||
                  startButtonDisabled
                  ? "#E0E0E0"
                  : "#4CAF50",
            }}
          >
            <b>Start Recording</b>
          </Button>
        </>
      )}
      {isRecording && !testData[questionNo - 1].answerResourcePath && !testData[questionNo - 1].disabled && (
        <>
          <p style={{ marginTop: "10px", marginBottom: "10px" }}>Click below button to stop recording</p>
          <Button
            variant="outlined"
            onClick={stopRecord}
            disabled={testData[questionNo - 1].answerResourcePath || testData[questionNo - 1].disabled}
            style={{
              borderColor: testData[questionNo - 1].answerResourcePath || testData[questionNo - 1].disabled ? "#CCCCCC" : "#CC0000",
              color: testData[questionNo - 1].answerResourcePath || testData[questionNo - 1].disabled ? "#CCCCCC" : "white",
              backgroundColor: testData[questionNo - 1].answerResourcePath || testData[questionNo - 1].disabled ? "#E0E0E0" : "#CC0000",
              marginBottom: "10px",
            }}
          >
            <b>Stop Recording</b>
          </Button>
        </>
      )}

      <div style={{ display: "none", marginTop: "10px" }}>
        <TextField id="outlined-search" label="Enter your Answer" type="search" variant="outlined" value={filename} onChange={onAnswerText} />
      </div>

      <div>
        <div style={{ display: "none" }}>
          <Grid container>
            <AppBar position="static">
              <Toolbar variant="">
                <Typography variant="h6" color="inherit">
                  What language are you going to speak in?
                </Typography>
              </Toolbar>
            </AppBar>
            <Grid container spacing={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <FormControl>
                    <InputLabel>Language</InputLabel>
                    <MenuItem key={examDetail[0].speechlang + "-IN"} value={examDetail[0].speechlang + "-IN"}>
                      {examDetail[0].speechlang + "-IN"}
                    </MenuItem>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={6} style={{ paddingLeft: "40px", paddingTop: "10px" }}>
                  {listening ? (
                    <Button color="primary" onClick={() => this.stopListening()} variant="contained">
                      Stop
                    </Button>
                  ) : (
                    <Button color="primary" onClick={() => this.startListening()} variant="contained">
                      Start
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={5}>
              <Paper>
                Status: <span> {listening ? "Listening..." : "Finished"} </span> <br />
                <Typography variant="overline" gutterBottom>
                  Current utterances
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {interimText}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <p>
                <strong>
                  Sentiment analysis Score:{" "}
                  {emojiValue > 0
                    ? emojiValue < 5
                      ? `${emoji.get("slightly_smiling_face")}`
                      : emojiValue < 10
                        ? `${emoji.get("yum")}`
                        : emojiValue < 20
                          ? `${emoji.get("wink")}`
                          : emojiValue < 30
                            ? `${emoji.get("smile")}`
                            : `${emoji.get("joy")}`
                    : emojiValue < -2
                      ? `${emoji.get("confused")}`
                      : emojiValue < -5
                        ? `${emoji.get("pensive")}`
                        : emojiValue < -8
                          ? `${emoji.get("disappointed")}`
                          : emojiValue < -11
                            ? `${emoji.get("angry")}`
                            : emojiValue < -14
                              ? `${emoji.get("rage")}`
                              : `${emoji.get("neutral_face")}`}{" "}
                  {emojiValue}
                </strong>
              </p>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Translated Text</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ height: "150px", overflow: "scroll", display: "block" }}>
                    {finalisedText.map((str, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {str}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};
